import { render, staticRenderFns } from "./FlatDollarInput.vue?vue&type=template&id=23658673&"
import script from "./FlatDollarInput.vue?vue&type=script&lang=js&"
export * from "./FlatDollarInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports